import {
  defaultFacetedSearchFactory,
  defaultDynamicContentFactory,
} from "./search/index.js";

import { createApp } from "./search/factory.js";

/**
 * only init if results are included
 * TODO remove jquery dependecy!!
 */
export default function initEGHThreadSearch() {
  const searchResults = document.querySelector(".js-search-results");
  if (searchResults) {
    const searchId = searchResults.getAttribute("data-search-id");
    const searchApp = createApp(defaultFacetedSearchFactory(searchId));
    searchApp();
  }

  const dynamicResults = document.querySelectorAll(".js-dynamic-results");
  const dynamicFilterBar = document.querySelector(".js-dynamic-filter-bar");

  if (dynamicResults && dynamicFilterBar) {
    [...dynamicResults].forEach(function (item) {
      const searchId = item.getAttribute("data-search-id");
      const filterUid = item.parentElement
        .querySelector(".js-dynamic-filter-bar")
        .getAttribute("id");
      const containerUid = item.getAttribute("id");
      const dynamicContentApp = createApp(
        defaultDynamicContentFactory(
          searchId,
          `#${containerUid}`,
          `#${filterUid}`,
        ),
      );
      dynamicContentApp();
    });
  }
}
